import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const settingSlice = createSlice({
  name: 'setting',
  initialState: {
    mode: 'light',
    color: 'primary',
    deviceToken: '',
    notificationPermissionPrompt: 'default',
    language: {
      language: 'fa',
      direction: 'rtl',
    },
  },
  reducers: {
    setMode: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        mode: payload,
      };
    },
    setColor: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        color: payload,
      };
    },
    setLanguage: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        language: payload,
      };
    },
    setDeviceToken: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        deviceToken: payload,
      };
    },
    setNotificationPermission: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        notificationPermissionPrompt: payload,
      };
    },
  },
});

export const { setMode, setColor, setLanguage, setDeviceToken, setNotificationPermission } = settingSlice.actions;

export default settingSlice.reducer;
